<div pl-grid-el pl-grid="1/1@phone">
  <h2 class="myse-dashboard__section-title" [textContent]="'DASHBOARD.TEAMS.title' | translate"></h2>
</div>

<div pl-grid-el pl-grid="1/1@phone">
  <!-- Skeleton -->
  @if (!loaded) {
    <div
    class="myse-dashboard-skeleton--section-card myse-dashboard__full-card se-card"></div>
  }
  <!-- Empty State -->
  @if (loaded && !teams.length) {
    <se-fe-card
      class="myse-dashboard__full-card myse-dashboard__compact-card">
      <se-fe-card-content>
        <se-fe-empty-state seFeDataTitle="{{ 'DASHBOARD.TEAMS_EMPTY.title' | translate }}" seFeDataSize="500">
          {{ 'DASHBOARD.TEAMS_EMPTY.description' | translate }}
        </se-fe-empty-state>
      </se-fe-card-content>
    </se-fe-card>
  }

  @if (loaded && teams.length) {
    <se-fe-card
      class="myse-dashboard__full-card js-team-list">
      <se-fe-card-content style="margin:0; padding: 0;">
        <se-fe-list>
          @for (team of teams; track team) {
            <se-fe-list-item
              class="ba-dashboard__list-item">
              <se-fe-header
                [seFeDataSubtitle]="team.org_details?.name ? team.org_details.name : '' "
                size="600">
                <a seFeHeaderTitle class="pl-link" [href]="team.url">{{ team.name }}</a>
                <div seFeHeaderVisual>
                  @if (team.sportIcon) {
                    <se-fe-avatar
                      seFeDataType="team"
                      [seFeDataSport]="team.sportIcon === 'other' ? undefined :team.sportIcon"
                      seFeDataTeamColor="{{ '#' + team.primary_color }}"
                      seFeDataImgUrl="{{ team.imgUrl }}"
                      seFeDataSize="300">
                    </se-fe-avatar>
                  }
                </div>
                </se-fe-header
                >
              </se-fe-list-item>
            }
            <se-fe-list-footer class="dashboard-teams__footer">
              <span [textContent]="'DASHBOARD.TEAMS.display_message' | translate: { displayed: teams.length, total: teams.metadata.pagination.total }"></span>
              <a
                routerLink="/user/my-teams"
                class="se-list__more myse-dashboard__section-link"
                (click)="fireAnalytics()"
                [textContent]="'DASHBOARD.TEAMS.display_link' | translate">
              </a>
            </se-fe-list-footer>
          </se-fe-list>
        </se-fe-card-content>
      </se-fe-card>
    }
  </div>
